var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconInfinity = function SvgIconInfinity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.684 8.576a3.49 3.49 0 1 0 1.773 5.909l.303-.33a1 1 0 0 1 1.473 1.353l-.319.347-.03.03a5.49 5.49 0 1 1 .042-7.727l5.622 6.332a3.491 3.491 0 1 0-.006-4.975l-.303.33a1 1 0 0 1-1.473-1.353l.32-.347.03-.03a5.49 5.49 0 1 1-.042 7.727L8.45 9.51a3.5 3.5 0 0 0-1.767-.934"
  })));
};
export default SvgIconInfinity;